"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _reduxBatchedActions = require("redux-batched-actions");
var _sagas = require("../../utils/sagas");
var sessionTypes = _interopRequireWildcard(require("../session/types"));
var types = _interopRequireWildcard(require("./types"));
var websocketTypes = _interopRequireWildcard(require("../websocket/types"));
var _apis = require("./apis");
var _selectors = require("../session/selectors");
var _actions = require("../notification/actions");
var _schemas = require("./schemas");
var _constants = require("./constants");
var _selectors2 = require("./selectors");
var _constants2 = require("../app/constants");
var _selectors3 = require("../network/selectors");
var _actions2 = require("../users/actions");
var _actions3 = require("../members/actions");
var _middlewares = require("../network/middlewares");
var _actions4 = require("../websocket/actions");
var _api = require("../../utils/api");
var _actions5 = require("./actions");
var _uuid = require("../../utils/uuid");
var _time = require("../../utils/time");
var _types4 = require("../feedItems/types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:feed');
function* patchFeed(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_patch');
  try {
    var response = yield (0, _effects.call)(_apis.$patchFeed, action._feed, action.feed);
    if (!response.data.data) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F1'
      }));
    }
  } catch (e) {
    if ((0, _middlewares.isNetworkError)(e)) return;
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'F2',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchFeed');
  }
}
function deleteFeed(_ref) {
  var {
    _feed
  } = _ref;
  return function* () {
    _callbacks.default.get('analyticsLogEvent')('feed_delete');
    try {
      yield (0, _effects.call)(_apis.$deleteFeed, _feed);
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F3',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'deleteFeed');
    }
  }();
}
function* postMulticastFeed(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_multicast_post');
  try {
    var {
      feed,
      _users
    } = action;
    var feedData = _objectSpread(_objectSpread({}, feed), {}, {
      private: true
    });
    var response = yield (0, _effects.call)(_apis.$postMulticastFeed, feedData);
    var _feed = response.data.data.id;
    if (_users) {
      yield (0, _effects.put)((0, _actions3.inviteMemberIntoFeed)(_feed, _users));
    }
    yield* (0, _api.normalizeApiResponse)([response.data.data], [_schemas.feeds]);
    yield (0, _effects.put)((0, _actions5.setFeed)(_feed));
    _callbacks.default.get('onMulticastFeedCreated')(_feed);
  } catch (e) {
    if (!(0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F4',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postMulticastFeed');
    } else {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('network.error.timeout'),
        referenceError: 'F9',
        error: e
      }));
    }
  }
}
function* patchMulticastFeed(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_multicast_patch');
  try {
    var {
      _feed,
      feed,
      _users
    } = action;
    yield (0, _effects.call)(_apis.$patchMulticastFeed, _feed, feed);
    if (_users) {
      yield (0, _effects.put)((0, _actions3.inviteMemberIntoFeed)(_feed, _users));
    }
    _callbacks.default.get('onMulticastFeedUpdate')(_feed);
  } catch (e) {
    yield (0, _effects.put)((0, _actions.addNotification)({
      message: _i18n.default.translate('default.error'),
      referenceError: 'F5',
      error: e
    }));
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchMulticastFeed');
  }
}
function* postUnicastFeed(action) {
  _callbacks.default.get('analyticsLogEvent')('feed_unicast_post');
  try {
    var {
      _target
    } = action;
    var response = yield (0, _effects.call)(postAnchor, {
      _target
    });
    var {
      data: {
        _feed
      } = {}
    } = response || {};
    if (!_feed) {
      return yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F12'
      }));
    }
    var _feedCreated = yield (0, _effects.call)(getFeed, {
      _feed
    });
    if (!_feedCreated) {
      return yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F11'
      }));
    }
    _callbacks.default.get('onUnicastFeedCreated')(_feed);
  } catch (e) {
    if ((0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('network.error.timeout'),
        referenceError: 'F10',
        error: e
      }));
    } else {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F6',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postUnicastFeed');
    }
  }
}
function postAnchor(_ref2) {
  var {
    _target
  } = _ref2;
  return function* () {
    try {
      return yield (0, _effects.call)(_apis.$postAnchor, _target);
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F7',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postAnchor');
    }
  }();
}
function getFeed(_ref3) {
  var {
    _feed
  } = _ref3;
  return function* () {
    if (!_feed) return;
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getFeed, _feed);
      yield* (0, _api.normalizeApiResponse)(data, _schemas.feeds);
      yield (0, _effects.put)((0, _actions5.setFeed)(_feed));
      return _feed;
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getFeed');
    }
  }();
}
function getFeeds(_ref4) {
  var {
    type
  } = _ref4;
  return function* () {
    var batchedActions = [];
    if (type === websocketTypes.WS_CONNECT && !_config.default.feed.fetchOnWsReload) {
      return;
    }
    try {
      var _data$data, _data$data$forEach;
      var {
        data
      } = yield (0, _effects.call)(_apis.$getFeeds);
      var userToRetrieve = [];

      // HACK: if the post is only a file, the content is not present,
      // so we still display the previous content instead of the metasFile.
      (_data$data = data.data) === null || _data$data === void 0 || (_data$data$forEach = _data$data.forEach) === null || _data$data$forEach === void 0 || _data$data$forEach.call(_data$data, feed => {
        var _feed$lastItemPosted, _feed$lastItemPosted2, _feed$lastItemPosted3;
        if (feed !== null && feed !== void 0 && feed.lastItemPosted && !feed.lastItemPosted.content) {
          feed.lastItemPosted.content = null;
        }
        if (feed !== null && feed !== void 0 && feed.lastItemPosted && !feed.lastItemPosted.metasFile) {
          feed.lastItemPosted.metasFile = null;
        }

        // Store _user in an array to retrieve them later and store them in entities
        if (((feed === null || feed === void 0 || (_feed$lastItemPosted = feed.lastItemPosted) === null || _feed$lastItemPosted === void 0 ? void 0 : _feed$lastItemPosted.specialType) === 'join' || (feed === null || feed === void 0 || (_feed$lastItemPosted2 = feed.lastItemPosted) === null || _feed$lastItemPosted2 === void 0 ? void 0 : _feed$lastItemPosted2.specialType) === 'left') && (_feed$lastItemPosted3 = feed.lastItemPosted) !== null && _feed$lastItemPosted3 !== void 0 && _feed$lastItemPosted3._user) {
          userToRetrieve.push(feed.lastItemPosted._user);
        }
      });
      yield (0, _effects.put)((0, _actions2.getUsers)(userToRetrieve, true));
      var {
        result,
        batchedAction
      } = yield* (0, _api.normalizeApiResponse)(data.data, [_schemas.feeds], true);
      batchedActions.push(batchedAction);
      batchedActions.push((0, _actions5.setFeeds)(result));
    } catch (e) {
      yield (0, _effects.put)((0, _actions5.setErrorFeeds)(e));
      if (!(0, _middlewares.isNetworkError)(e)) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getFeeds');
      }
    }
    yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
  }();
}
function getAnchors(_ref5) {
  var {
    type
  } = _ref5;
  return function* () {
    var batchedActions = [];
    if (type === websocketTypes.WS_CONNECT && !_config.default.anchor.fetchOnWsReload) {
      return;
    }
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getAnchors);

      // HACK: if the post is only a file, the content is not present,
      // so we still display the previous content instead of the metasFile.
      data.forEach(anchor => {
        var _anchor$feed, _anchor$feed2;
        if ((_anchor$feed = anchor.feed) !== null && _anchor$feed !== void 0 && _anchor$feed.lastItemPosted && !anchor.feed.lastItemPosted.content) {
          anchor.feed.lastItemPosted.content = null;
        }
        if ((_anchor$feed2 = anchor.feed) !== null && _anchor$feed2 !== void 0 && _anchor$feed2.lastItemPosted && !anchor.feed.lastItemPosted.metasFile) {
          anchor.feed.lastItemPosted.metasFile = null;
        }
      });
      var {
        batchedAction,
        result
      } = yield* (0, _api.normalizeApiResponse)(data, [_schemas.anchors], true);
      batchedActions.push(batchedAction);
      batchedActions.push((0, _actions5.setAnchors)(result));
    } catch (e) {
      if (!(0, _middlewares.isNetworkError)(e)) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getAnchors');
      }
    }
    yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
  }();
}
function* handleWsPostAnchor(action) {
  var batchedActions = [];
  var {
    batchedAction,
    result
  } = yield* (0, _api.normalizeApiResponse)(action.payload, _schemas.anchors, true);
  batchedActions.push(batchedAction);
  batchedActions.push((0, _actions5.setAnchor)(result));
  yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
}
function* postAcknowledgement(action) {
  logger.log('postAcknowledgement', {
    action
  });
  if (_callbacks.default.get('getAppState')() === _constants2.APP_STATES.BACKGROUND) return;
  try {
    yield (0, _effects.call)(_apis.$postAcknowledgement, action._feed);
  } catch (e) {
    if (!(0, _middlewares.isNetworkError)(e)) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'postAcknowledgement');
    }
  }
}
function* handleWsPutFeed(action) {
  var _action$payload, _action$payload2, _action$payload3;
  if ((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.lastItemPosted && !action.payload.lastItemPosted.content) {
    // HACK: if the post is only a file, the content is not present,
    // so we still display the previous content instead of the metasFile.
    action.payload.lastItemPosted.content = null;
  }
  if ((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.lastItemPosted && !action.payload.lastItemPosted.metasFile) {
    // HACK: if the post is only a file, the content is not present,
    // so we still display the previous content instead of the metasFile.
    action.payload.lastItemPosted.metasFile = null;
  }
  if ((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.lastItemPosted && !action.payload.lastItemPosted.specialType) {
    // fix problem with mergeEntities where specialType was still present in redux because the lastItemPosted
    // was merged and not replaced
    action.payload.lastItemPosted.specialType = null;
  }
  try {
    logger.log('handleWsPutFeed', {
      action
    });
    yield* (0, _api.normalizeApiResponse)([action.payload], [_schemas.feeds]);
    yield (0, _effects.put)((0, _actions5.setAcknowledgement)(action.payload.id, action.payload.updatedAt));
    var hasFeed = yield (0, _effects.select)((0, _selectors2.hasFeedByIdSelector)(action.payload.id));
    if (!hasFeed) {
      yield (0, _effects.put)((0, _actions5.setFeed)(action.payload.id));
    }
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleWsPutFeed');
  }
}
function* handleWsPutAcknowledgements(action) {
  logger.log('handleWsPutAcknowledgements', {
    action
  });
  if (!action.payload) return;
  yield (0, _effects.put)((0, _actions5.setUserAcknowledgements)(action.payload.feeds));
  if (action.payload.feedsReference) {
    yield (0, _effects.put)((0, _actions5.setAcknowledgements)(action.payload.feedsReference));
  }
}
function* handleWsPatchAcknowledgements(action) {
  logger.log('handleWsPatchAcknowledgements', {
    action
  });
  if (!action.payload) return;
  if (action.payload.feeds) {
    yield (0, _effects.put)((0, _actions5.updateUserAcknowledgements)(action.payload.feeds));
  }
  if (action.payload.feedsReference) {
    yield (0, _effects.put)((0, _actions5.updateAcknowledgements)(action.payload.feedsReference));
  }
}
function* handleWsPostFeed(action) {
  try {
    var batchedActions = [];
    var {
      result,
      batchedAction
    } = yield* (0, _api.normalizeApiResponse)([action.payload], [_schemas.feeds], true);
    batchedActions.push(batchedAction);
    batchedActions.push((0, _actions5.setFeed)(result));
    yield (0, _effects.put)((0, _reduxBatchedActions.batchActions)(batchedActions));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleWsPostFeed');
  }
}
function requestDeleteAnchor(_ref6) {
  var {
    _anchor
  } = _ref6;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$deleteAnchor, _anchor);
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('feedList.feedBack.deletedSubscription')
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'F8',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'requestDeleteAnchor');
    }
  }();
}
function* waitAfterWS(source) {
  logger.log('waitAfterWS', source);
  var isWsLaunchable = yield (0, _effects.select)(_selectors3.getIsWsCanLaunchSelector);
  if (isWsLaunchable) {
    yield (0, _effects.put)((0, _actions4.launchWebsocket)());
    logger.log('launchWebsocket -- waitAfterWS');
    yield (0, _effects.take)(websocketTypes.WS_CONNECT);
  }
  return true;
}
function handleSubscribeTyping(_ref7) {
  var {
    _feed
  } = _ref7;
  return function* () {
    logger.log('handleSubscribeTyping');
    if (!_feed) return;
    try {
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var typingSubscriptions = yield (0, _effects.select)(_selectors2.getSubscriptionFeeds);
      if (!typingSubscriptions[_feed]) {
        yield (0, _effects.put)((0, _actions5.updateSubscriptionFeedTyping)(_feed, true));
        yield (0, _effects.call)(waitAfterWS, 'handleSubscribeTyping');
        yield (0, _effects.call)(_apis.$subscribeFeedTyping, _feed, _client);
      }
    } catch (e) {
      if (!(0, _middlewares.isNetworkError)(e)) {
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleSubscribeTyping');
      }
    }
  }();
}
function handleUnsubscribeTyping(_ref8) {
  var {
    _feed
  } = _ref8;
  return function* () {
    logger.log('handleUnsubscribeTyping');
    if (!_feed) return;
    try {
      var _client = yield (0, _effects.select)(_selectors._currentClientSelector);
      var typingSubscriptions = yield (0, _effects.select)(_selectors2.getSubscriptionFeeds);
      if (typingSubscriptions[_feed]) {
        yield (0, _effects.put)((0, _actions5.updateSubscriptionFeedTyping)(_feed, false));
        yield (0, _effects.call)(_apis.$unsubscribeFeedTyping, _feed, _client);
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleUnSubscribeTyping');
    }
  }();
}
function handleWSTyping(_ref9) {
  var {
    payload
  } = _ref9;
  return function* (_typing$_feed) {
    if (!payload || !payload.createdAt || !payload._feed || !payload._users) return;
    logger.log('handleWSTyping', JSON.stringify({
      payload
    }));
    var _me = yield (0, _effects.select)(_selectors.getUserId);
    var _users = payload._users.filter(_user => _user !== _me);
    var {
      _feed,
      createdAt,
      users
    } = payload;
    var id = (0, _uuid.generate)();
    if (_users.length) {
      var _payload$duration;
      var duration = ((_payload$duration = payload.duration) !== null && _payload$duration !== void 0 ? _payload$duration : _constants.DELAY_BETWEEN_TYPING) * 1000; // payload duration is in sec
      var data = {
        id,
        createdAt,
        duration,
        _feed,
        expiredAt: (0, _time.websocketClockSync)(createdAt) + duration,
        _users,
        users
      };
      yield (0, _effects.put)((0, _actions5.setUserTyping)(data));
      // reset store after duration
      yield (0, _effects.delay)(data.expiredAt - Date.now());
    }
    var typing = yield (0, _effects.select)(_selectors2.feedTypingSelector);
    if ((typing === null || typing === void 0 || (_typing$_feed = typing[_feed]) === null || _typing$_feed === void 0 ? void 0 : _typing$_feed.id) === id || !_users.length) {
      // expired event or nobody writing, should be removed from store
      yield (0, _effects.put)((0, _actions5.resetUserTyping)(_feed));
    }
  }();
}
var lastTypingSent = {};
function handleMyUserTyping(_ref10) {
  var {
    _feed
  } = _ref10;
  return function* () {
    logger.log('handleMyUserTyping', {
      _feed,
      lastTypingSent
    });
    if (!_feed) return;
    if (!lastTypingSent[_feed]) lastTypingSent[_feed] = 0;
    try {
      var now = Date.now();
      if (now - lastTypingSent[_feed] > _constants.DELAY_BETWEEN_TYPING * 1000) {
        lastTypingSent[_feed] = now;
        yield (0, _effects.put)((0, _actions4.websocketSend)({
          code: types.MY_USER_TYPING,
          payload: {
            _feed
          }
        }));
      }
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'handleMyUserTyping');
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)([types.REQUEST_GET_FEEDS, websocketTypes.WS_CONNECT, sessionTypes.REQUEST_LOGIN_SUCCESS], getFeeds), (0, _sagas.takeEvery)([_types4.WS_PUT_FEED_ITEM, types.REQUEST_GET_FEED], getFeed), (0, _sagas.takeLatest)(types.REQUEST_POST_MULTICAST, postMulticastFeed), (0, _sagas.takeLatest)(types.REQUEST_PATCH_MULTICAST, patchMulticastFeed), (0, _sagas.takeLatest)(types.REQUEST_POST_UNICAST, postUnicastFeed), (0, _sagas.takeLatest)(types.REQUEST_DELETE_FEED, deleteFeed), (0, _sagas.takeLatest)(types.REQUEST_PATCH_FEED, patchFeed), (0, _sagas.takeEvery)(types.WS_USER_TYPING, handleWSTyping), (0, _sagas.takeLatest)(types.MY_USER_TYPING, handleMyUserTyping), (0, _sagas.takeLatest)(types.SUBSCRIBE_FEED_TYPING, handleSubscribeTyping), (0, _sagas.takeLatest)(types.UNSUBSCRIBE_FEED_TYPING, handleUnsubscribeTyping), (0, _sagas.takeLatest)(types.REQUEST_POST_ANCHOR, postAnchor), (0, _sagas.throttle)(_constants2.sagasTiming, [types.REQUEST_GET_ANCHORS, websocketTypes.WS_CONNECT, sessionTypes.REQUEST_LOGIN_SUCCESS], getAnchors), (0, _sagas.takeLatest)(types.WS_POST_ANCHOR, handleWsPostAnchor), (0, _sagas.takeLatest)(types.REQUEST_DELETE_ANCHOR, requestDeleteAnchor), (0, _sagas.takeEvery)(types.WS_PUT_FEED, handleWsPutFeed), (0, _sagas.takeEvery)(types.WS_POST_FEED, handleWsPostFeed), (0, _sagas.takeLatest)(types.WS_PUT_ACKNOWLEDGEMENTS, handleWsPutAcknowledgements), (0, _sagas.takeLatest)(types.WS_PATCH_ACKNOWLEDGEMENTS, handleWsPatchAcknowledgements), (0, _sagas.takeEvery)(types.REQUEST_POST_ACKNOWLEDGEMENT, postAcknowledgement)]);
}
module.exports = exports.default;